import { ConsentStatus } from "@/api/dtos";
import { createContext } from "react";


export enum EConsentUserType {
    Participant = 1,
    Investigator = 2,
    Unknown = 3
}

export const stringToEConsentUserType = (value?: string | null) => {
    if (!value) {
        return EConsentUserType.Unknown;
    }

    switch (value) {
        case "participant":
            return EConsentUserType.Participant;
        case "investigator":
            return EConsentUserType.Investigator;
        case "unknown":
            return EConsentUserType.Unknown;
        default:
            return EConsentUserType.Unknown;
    }
}

export const eConsentUserTypeToString = (value?: EConsentUserType | null) => {
    if (!value) {
        return EConsentUserType.Unknown;
    }

    switch (value) {
        case EConsentUserType.Participant:
            return "participant";
        case EConsentUserType.Investigator:
            return "investigator";
        case EConsentUserType.Unknown:
        default:
            return "unknown";
    }
}

export interface IEConsentContext {
    investigators: { [index: string]: string; } | null | undefined;
    principalInvestigator: string | null | undefined;
    userType: EConsentUserType | null;
    participantAccessGuid?: string;
    participantName?: string;
    picfDownloadUrl?: string;
    picfVersion?: string;
    readOnly?: boolean;
    consentStatus?: ConsentStatus;
}

const EConsentContext = createContext<IEConsentContext>({
    investigators: null,
    principalInvestigator: null,
    userType: null
});

export default EConsentContext;
